/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BabylonSecondlyScheduleControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string OK
     * @throws ApiError
     */
    public fetchBabylonFaucetClaim(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/secondly/faucet/claim',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setBlockAvgCreatedTime2(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/secondly/block/avgcreatedtime',
        });
    }

}
